import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartRoutingModule } from './cart-routing.module';
import { CartWidgetComponent } from './cart-widget/cart-widget.component';
import { CartComponent } from './cart.component';

@NgModule({
  declarations: [CartComponent, CartWidgetComponent],
  imports: [CommonModule, CartRoutingModule, SharedModule],
  exports: [CartWidgetComponent],
})
export class CartModule {}
